import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import loc from 'owa-localize';
import { getSupportedCultures } from 'owa-regional-option';
import CultureInfoData from 'owa-service/lib/contract/CultureInfoData';
import * as React from 'react';
import { trace } from 'owa-trace';
import { localeDropdownLabel } from './LanguagePickerDialog.locstring.json';
import { isProofingSupportLocale } from '../utils/isProofingSupportLocale';

const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 300 },
};

let styles = require('./EditorOptions.scss');

// It's possible that some cultures have multiple locales with the name name (e.g. two different cultures that each use en-us).
// Since the proofing is not that granular, we just want to filter out the duplicates.
function filterLocales(cultures: CultureInfoData[]): CultureInfoData[] {
    const filteredList: CultureInfoData[] = [];
    cultures.forEach(culture => {
        if (culture.Name && isProofingSupportLocale(culture.Name)) {
            filteredList.push(culture);
        }
    });

    return filteredList;
}

export interface LanguagePickerProps {
    selectedLocale: string;
    onChange: (selectedLocale: string) => void;
}

function LanguagePicker(props: LanguagePickerProps) {
    const [selectedLocale, setSelectedLocale] = React.useState(props.selectedLocale);

    // Initialize the list of options:
    const cultures = filterLocales(getSupportedCultures());
    const options: { key: string; text: string }[] = [];
    cultures.forEach((culture: CultureInfoData) => {
        if (culture.Name && culture.NativeName) {
            options.push({ key: culture.Name, text: culture.NativeName });
        }
    });

    const onDropdownChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            const newLocale = option.key as string;
            trace.info(`[LanguagePickerDialog] Setting language: ${newLocale}`);
            setSelectedLocale(newLocale);
            props.onChange(newLocale);
        }
    };

    return (
        <Dropdown
            label={loc(localeDropdownLabel)}
            selectedKey={selectedLocale}
            options={options}
            disabled={false}
            styles={dropdownStyles}
            className={styles.localeDropdown}
            onChange={onDropdownChange}
        />
    );
}

export default LanguagePicker;
